import styled, { css } from 'styled-components'

import type { ListItemProps } from './interfaces'

export const Container = styled.div<{
  variant?: ListItemProps['variant']
  state?: ListItemProps['state']
  onClick?: () => void
}>`
  position: relative;
  width: 100%;
  padding: 16px;
  border-radius: var(--radius-large);
  background-color: ${({ state }) =>
    state === 'enabled'
      ? 'var(--color-surface-neutral-softer)'
      : 'var(--color-surface-neutral-softest)'};
  transition: transform 0.3s ease, background-color 0.2s ease;
  cursor: ${({ onClick, state }) => (onClick && state === 'enabled' ? 'pointer' : 'default')};

  ${({ state, onClick }) =>
    state === 'enabled' &&
    onClick &&
    css`
      &:active {
        transform: scale(0.97);
        background-color: var(--color-surface-neutral-soft);
      }
    `}

  ${({ state }) =>
    state === 'disabled' &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  min-width: 0;
`

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  align-items: flex-start;
`

export const TrailingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
`

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--color-border-neutral-default);
  margin-top: 16px;
`
